module.exports = __webpack_public_path__ + "static/media/customer_overview_vector.a12a1cf1.svg";